import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedViewerService } from '@reconcept-platform/shared/data-access';
import { TextLinkActionComponent } from '@reconcept-platform/shared/ui/standalone/button';
import { derivedAsync } from 'ngxtension/derived-async';
import { map, of } from 'rxjs';

export const infoBoxColors = ['default', 'primary', 'positive', 'negative', 'alert', 'ai'] as const;
export type InfoBoxColor = (typeof infoBoxColors)[number];

@Component({
  selector: 'rcp-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  imports: [FontAwesomeModule, TranslatePipe, TextLinkActionComponent],
  host: { '[class.hidden]': 'hidden()' },
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class InfoBoxComponent {
  private viewerService = inject(SharedViewerService);

  dismissableId = input<string>();
  icon = input<IconProp>();
  title = input<string>();
  color = input<InfoBoxColor>('default');

  infoBoxDismissableId = computed(() => {
    return this.dismissableId() ? `info-box-hidden-${this.dismissableId()}` : undefined;
  });

  hidden = derivedAsync<boolean>(() => {
    if (!this.infoBoxDismissableId()) {
      return of(false);
    }

    return (
      this.viewerService
        // @ts-expect-error TS2345 argument not assignable
        .watchUiPreference(this.infoBoxDismissableId())
        .pipe(map((wasDismissed) => wasDismissed === true))
    );
  });

  dismiss(infoBoxDismissableId: string, $event: Event) {
    $event.preventDefault();

    this.viewerService.storeUiPreference(infoBoxDismissableId, true).subscribe();
  }
}
